module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navigation"
  }, [_c('Desktop', {
    staticClass: "navigation--desktop",
    attrs: {
      "props": _vm.props
    }
  }), _c('Mobile', {
    staticClass: "navigation--mobile",
    attrs: {
      "props": _vm.props
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2acdd41d","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/navigation/navigation.pug
// module id = 690
// module chunks = 1